import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import {Logger} from "dce-logger";
import Quill from 'quill';
import {OpenDialog} from "../../index";
import QuillToolbarIcons from "./assets/QuillToolbarIcons";
import QuillLoader from "./internal/QuillLoader";

interface QuillTextareaProps {
    height: number
}

@Dce("QuillTextarea")
export default class QuillTextarea extends DceComponent<QuillTextareaProps> {

    private logger = Logger.of("Quill");

    private block: JQuery<HTMLElement>;
    private quillBlock: JQuery<HTMLElement>;

    private quill: Quill;
    private undoBtn: JQuery<HTMLElement>;
    private redoBtn: JQuery<HTMLElement>;

    constructor(elem: DceHTMLElement, props: QuillTextareaProps) {
        super(elem, props);
        this.logger.debug("Init Quill");

        this.block = $(elem);
        this.quillBlock = $('<div style="height: ' + this.props.height +'px;"/>');

        this.block.after(this.quillBlock);

        let toolbarButtons= [
            [{ 'header': [2, 3, false] }],
            ['undo', 'redo'],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'script': 'sub'}, { 'script': 'super' }],
            ['imagebrowse'],
            ['clean'],
        ];

        QuillLoader.load().then(Q => {

            const QDelta = Q.Module.import('delta')
            const icons = Q.Module.import('ui/icons');

            icons.imagebrowse = QuillToolbarIcons.IMAGEBROWSE;

            // @ts-ignore
            this.quill = new Q.Clazz(this.quillBlock[0], {
                modules: {
                    toolbar: {
                        container: toolbarButtons,
                        handlers: {
                            'undo': this.undoHandler,
                            'redo': this.redoHandler,
                            'imagebrowse': (a:any) => { }
                        }
                    }
                },
                placeholder: '',
                theme: 'snow'
            });

            if(this.block.val() != ''){
                try {
                    let v = JSON.parse(this.block.val() as string);
                    this.quill.setContents(v);
                } catch(e) {
                    this.logger.error(e);
                }
            }

            this.setupUndoRedoButtons();
            this.setupImageBrowse(QDelta);

            this.quill.on('text-change', (e:any) => {
                this.changeListener()
            });
        })

    }

    private changeListener(){

        var content = this.quill.getContents();
        this.block.val(JSON.stringify(content['ops']));

        let history = this.quill.getModule('history');
        
        if(history.stack.undo.length > 0){
            this.undoBtn.removeClass('disabled');
        }else{
            this.undoBtn.addClass('disabled');
        }

        if(history.stack.redo.length > 0){
            this.redoBtn.removeClass('disabled');
        }else{
            this.redoBtn.addClass('disabled');
        }

    }


    private undoHandler(v:any){
        this.quill.getModule('history').undo();
        this.quill.focus();
    }

    private redoHandler(v:any){
        this.quill.getModule('history').redo();
        this.quill.focus();
    }

    private setupUndoRedoButtons(){
        this.undoBtn = this.quillBlock.parent().find('.ql-undo');
        this.redoBtn = this.quillBlock.parent().find('.ql-redo');

        this.undoBtn.html(QuillToolbarIcons.UNDO)
            .addClass('disabled');

        this.redoBtn.html(QuillToolbarIcons.REDO)
            .addClass('disabled');

    }


    private setupImageBrowse(QDelta: any){
        let btn = this.quillBlock.parent().find('.ql-imagebrowse');

        let openDialog = new OpenDialog(btn[0] as DceHTMLElement, {
            url: '/file_browser',
            target: "#main",
            bindClick: true,
        });

        openDialog.addOnClose((d, e) => {

            let saved = d.getFormSaved();

            if(saved){
                let data = d.getFormResponse();

                let src = null;
                if(data.data.hasOwnProperty('src')){
                    src = data.data.src;
                }

                if(null != src){

                    let range = this.quill.getSelection(true);

                    this.quill.updateContents(
                        new QDelta()
                            .retain(range.index)
                            .delete(range.length)
                            .insert({ image: src}, {
                                'alt': "jakiś alt"
                            }),
                        "user" //Emitter.sources.USER
                    );

                    this.quill.setSelection(
                        range.index + 1, 0,
                        "silent"
                    );

                }

            }

        });


    }


    defaultProps(): QuillTextareaProps {
        return {
            height: 200
        }
    }
}
